import { configureStore } from '@reduxjs/toolkit';
import auth from './providers/AuthContext';

export default configureStore({
  reducer: {
    auth: auth,
  },
});
